import { pathOr } from 'ramda';

import { getProductPackReference, ProductPack } from '@/models/core/ProductPack';
import { Price } from '@/models/core/values';
import { PackItem } from '@/models/core/PackItem';

import { PRODUCT_REFERENCES } from '@/constants/treatment';

const REFERENCE_WHITE_LIST = new Set([
  PRODUCT_REFERENCES.NEXULTRA_O1,
  PRODUCT_REFERENCES.NEXULTRA_O2,
  PRODUCT_REFERENCES.NEXULTRA_1,
  PRODUCT_REFERENCES.NEXULTRA_2,
  PRODUCT_REFERENCES.NEXULTRA_3,
  PRODUCT_REFERENCES.NEXULTRA_B1,
  PRODUCT_REFERENCES.NEXULTRA_B2,
  PRODUCT_REFERENCES.UNIVERSKIN_H,
  PRODUCT_REFERENCES.UNIVERSKIN_M,
  PRODUCT_REFERENCES.GEL_30,
  PRODUCT_REFERENCES.GEL_100,
  PRODUCT_REFERENCES.NEXULTRA_L1,
  PRODUCT_REFERENCES.NEXULTRA_L2,
  PRODUCT_REFERENCES.SUNSCREEN_SPF,
  PRODUCT_REFERENCES.SUNSCREEN_CRM,
  PRODUCT_REFERENCES.SUNSCREEN_FLD,
  PRODUCT_REFERENCES.NEXULTRA_UV,
 PRODUCT_REFERENCES.NEXULTRA_P_LIGHT,
  PRODUCT_REFERENCES.NEXULTRA_P_RICH
]);

const validatePricesDto = pricesDto => {
  if (!pricesDto || !pricesDto.productPrices || !pricesDto.currencyCode) {
    throw Error('Invalid pricesDto');
  }
};

export const getCurrencyFromPricesDto = pricesDto => pricesDto.currencyCode;

/**
 * Get product price.
 *
 * @param {ProductPack} productPack
 * @param {Object} pricesDto
 * @return {Price}
 */
export const getProductPrice = (productPack, pricesDto) => {
  validatePricesDto(pricesDto);

  const productReference = getProductPackReference(productPack);
  const prices = pricesDto.productPrices;
  const priceObject = prices.find(({ reference }) => reference === productReference);
  const priceValue = priceObject.chosenPrice;

  return Price(priceValue, pricesDto.currencyCode);
};

/**
 * Check is there a price for product.
 *
 * @param {ProductPack} productPack
 * @param {Object} pricesDto
 * @return {boolean}
 */
export const hasPriceForProduct = (productPack, pricesDto) => {
  validatePricesDto(pricesDto);

  const productReference = getProductPackReference(productPack);
  const prices = pricesDto.productPrices;
  const priceObject = prices.find(({ reference }) => reference === productReference);

  return !!priceObject;
};

/**
 * Get complementary products packs from prices dto.
 *
 * @param {Object} pricesDto
 * @return {ProductPack[]}
 */
export const getComplementaryProductPacks = pricesDto => {
  const currency = getCurrencyFromPricesDto(pricesDto);
  const prices = pathOr([], ['productPrices'], pricesDto).reduce((acc, priceObject) => {
    const { reference } = priceObject;

    if (REFERENCE_WHITE_LIST.has(reference)) {
      const { chosenPrice } = priceObject;

      acc[reference] = Price(chosenPrice, currency);
    }

    return acc;
  }, {});

  return Array.from(REFERENCE_WHITE_LIST).map(reference => {
    const price = prices[reference] || Price(0, currency);
    const status = prices[reference] ? 'available' : 'not-available';
    const item = PackItem({ reference, status, price });

    return ProductPack([item]);
  });
};
